import { Type } from "@sinclair/typebox";
import SchemaValidator from "../schema-validator";
import { OptionalOrNull } from "../shared-schemas";

const assessmentInfoType = Type.Object({
	id: Type.Number(),
	courseId: Type.Number(),
	quizId: Type.String(),
	quizInfo: OptionalOrNull(
		Type.Union([
			Type.String(),
			Type.Intersect([
				Type.Object({
					name: OptionalOrNull(Type.String()),
				}),
				Type.Record(Type.String(), Type.Any()),
			]),
		]),
	),
	isDeleted: Type.Boolean(),
	createdAt: OptionalOrNull(Type.Union([Type.Number(), Type.String()])),
	updatedAt: OptionalOrNull(Type.Union([Type.Number(), Type.String()])),
});

const assessmentInfo = new SchemaValidator(assessmentInfoType);
const assessmentInfoArray = new SchemaValidator(Type.Array(assessmentInfoType));
const assessmentInfoList = new SchemaValidator(
	Type.Array(
		Type.Intersect([
			assessmentInfoType,
			Type.Object({
				proctoringOptions: OptionalOrNull(
					Type.Object({
						enabled: OptionalOrNull(Type.Boolean()),
						isLiveProctored: OptionalOrNull(Type.Boolean()),
						isLivePopIn: OptionalOrNull(Type.Boolean()),
						enablePostReview: OptionalOrNull(Type.Boolean()),
						isExtension: OptionalOrNull(Type.Boolean()),
						isLockdown: OptionalOrNull(Type.Boolean()),
						isMobile: OptionalOrNull(Type.Boolean()),
						requiresIncognito: OptionalOrNull(Type.Boolean()),
					}),
				),
			}),
		]),
	),
);

const standaloneStudent = Type.Object({
	userId: Type.Number(),
	firstName: Type.String(),
	lastName: Type.String(),
	email: Type.String(),
});
const standaloneStudentList = new SchemaValidator(Type.Array(standaloneStudent));

const suffixUpdateResult = new SchemaValidator(
	Type.Object({
		ok: Type.Boolean(),
		exists: Type.Boolean(),
		newName: Type.Union([Type.String(), Type.Null()]),
	}),
);

const assessmentMonthlyCountType = Type.Object({
	count: Type.Number(),
	monthlyCounts: Type.Array(Type.Number()),
});

const assessmentMonthlyCountList = new SchemaValidator(
	Type.Object({
		liveAssessments: assessmentMonthlyCountType,
		nonLiveAssessments: assessmentMonthlyCountType,
	}),
);

const validate = new SchemaValidator(
	Type.Object({
		didValidate: Type.Boolean(),
		doPasswordsMatch: Type.Boolean(),
		isPasswordRequired: Type.Boolean(),
	}),
);

const synchronize = new SchemaValidator(
	Type.Object({
		didSynchronize: Type.Boolean(),
		doPasswordsMatch: Type.Boolean(),
		isPasswordRequired: Type.Boolean(),
	}),
);

export default {
	assessmentInfo,
	assessmentInfoArray,
	assessmentInfoList,
	standaloneStudentList,
	suffixUpdateResult,
	assessmentMonthlyCountList,
	validate,
	synchronize,
};
